import { useQueryClient } from '@tanstack/react-query';
import useApiMutation from '../../../useApiMutation';
import keys from './keys';

const useDeleteMarketplaceProfile = () => {
  const queryClient = useQueryClient();

  const mutation = useApiMutation({
    getRequestUrl: ({ showId, profileId }) =>
      `/shows/${showId}/marketplace/profiles/hosts/${profileId}`,
    method: 'DELETE',
    onSuccess: (data) => {
      queryClient.invalidateQueries(keys.hostProfiles({ showId: data.showId }));
    },
  });

  return {
    deleteHostProfile: mutation.mutate,
    isDeleteHostProfileLoading: mutation.isLoading,
    isDeleteHostProfileError: mutation.isError,
    isDeleteHostProfileSuccess: mutation.isSuccess,
    ...mutation,
  };
};

export default useDeleteMarketplaceProfile;
